module.exports = "<p style=\"margin-top:28px;margin-bottom:10px;height:42px\"><img __badge_src__/></p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/services/badge/badge-image.html
// module id = 1200
// module chunks = 3